/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CreateDateTime } from './createDateTime';
import { LastUpdateByUserId } from './lastUpdateByUserId';
import { UpdateDateTime } from './updateDateTime';

/**
 * Tracks user-specific favorite reports. Report Favorites remain the same across all venues which the user has access to in a particular organisation.
 */
export interface ReportFavouriteView { 
    /**
     * Primary Key for the favorite.
     */
    reportFavouriteId?: number;
    /**
     * ID of the user; unique with report_id + org_ref_id to prevent duplicates.
     */
    userId?: string;
    /**
     * Foreign key referencing Reports table.
     */
    reportId?: number;
    organisationId?: string;
    createDateTime?: CreateDateTime;
    updateDateTime?: UpdateDateTime;
    lastUpdateByUserId?: LastUpdateByUserId;
}